  <template>
  <v-layout v-if="breadcrumbs" row class="align-center layout px-4 pt-4 app--page-header">
    <v-breadcrumbs divider="-" :items="breadcrumbs"></v-breadcrumbs>
  </v-layout>
</template>

<script>
import menu from '@/api/menu'
export default {
  data() {
    return {
      title: ''
    }
  },
  computed: {
    breadcrumbs: function() {
      let breadcrumbs = []
      menu.forEach(item => {
        if (item.items) {
          let child = item.items.find(i => {
            return i.component === this.$route.name
          })
          if (child) {
            breadcrumbs.push(item.title)
            breadcrumbs.push(child.title)
            this.title = child.title
          }
        } else {
          if (item.name === this.$route.name) {
            this.title = item.title
            breadcrumbs.push(item.title)
          }
        }
      })
      return breadcrumbs
    }
  }
}
</script>
